<button
    (click)="onSubmitHandler()"
    [ngStyle]="{
      'background': 'var(--interaction-btn-submit-bg, ' + color + ')',
      'color': 'var(--interaction-btn-submit-color, ' + colorInverse + ')'
    }"
    [ngClass]="{'tight': tightLayout}"
>{{text | translate}}</button>
